export default {
  en: {
    login: {
      heading: 'Online seminars made easy!',
      subHeading: '',
      forgotPassword: 'Forgot your account password?',
      remember: 'Remember me',
      passwordLable: 'Password',
      emailLable: 'Email address',
      requiredField: 'This field is required',
      buttonLabel: 'login',
      invalidPassword: 'Invalid password, please try again',
      noUser: 'User not found, please try again!',
      emailNotFound: 'Email not found!',
      newAccountLabel: 'Create a new account'
    },
    footerMenu: {
      about:
        '<a class="link white" href="https://www.anets.co.jp/e/">About Us</a>',
      terms:
        '<a class="link black" href="https://workshop-live.com/term-en.html?la=en">Terms of Service</a>',
      policy:
        '<a class="link black" href="https://workshop-live.com/privacy-en.html?la=en">Privacy Policy</a>',
      developedBy: 'created by '
    },
    loggedOutNavigation: {
      home: 'HOME',
      register: 'create account'
    },
    loggedInNavigation: {
      adminDashboard: 'Admin Dashboard',
      guestDashboard: 'Guest Dashboard',
      roleAdmin: 'Administer',
      roleGuest: 'Guest',
      contacts: 'Contacts',
      settings: 'Settings',
      recordings: 'Recordings',
      seminars: 'Seminars',
      rooms: 'Rooms',
      upgrade: 'upgrade account',
      new: 'New Seminar',
      modalHeader: 'Upgrade account to Admin?',
      upgradeConfirmation: 'Are you sure you want to upgrade to a Admin?',
      upgradeModalBody:
        'Admin users can create a new seminar and also join in a seminar invited by others.',
      cancel: 'cancel',
      gotoAdmin: 'Go to admin dashboard',
      gotoGuest: 'Go to guest dashboard',
      logout: 'logout',
      adminster: 'Guest cannot create new seminars.',
      manual: 'Manual',
      news: 'Notice'
    },
    seminar: {
      registration: 'register',
      beginsIn: 'Seminar begins in',
      register: 'Go to Registration Page',
      guests: 'Guests',
      open: 'Go to Seminar Page',
      upcoming: 'upcoming',
      previous: 'previous',
      deleteSeminar: 'delete seminar',
      declineInvite: 'decline invitation',
      acceptInvite: 'accept invitation',
      openSeminar: 'Seminar URL',
      deleteModalHeading: 'Delete Seminar?',
      deleteConfirm: {
        sure: 'Are you sure you want to DELETE ',
        seminar: ' Seminar? ',
        guestNumbers: ' '
      },
      deleteButtonLabel: 'delete seminar',
      delMessage: 'Workshop seminar Room has been removed',
      schedule: 'Seminar schedule',
      scheduleUpdated: 'Schedule Updated',
      date: 'Seminar Date',
      time: '12hr Format',
      save: 'save',
      notScheduled: 'Time not schedued',
      dateNot: 'Date not scheduled',
      scheduleNext: 'Please schedule your next seminar',
      createNew: 'Create new Seminar',
      seminarName: 'Seminar name',
      on: 'ON',
      off: 'OFF',
      record: 'Record Seminar?',
      create: 'create',
      mobile: 'Discussion Mode?'
    },
    seminarActions: {
      members: 'Members',
      select: 'selected',
      selectList: 'select list',
      tabs: {
        details: 'details',
        schedule: 'schedule',
        invite: 'invite',
        recording: 'recording',
        settings: 'settings'
      },
      name: 'Seminar name',
      description: 'Seminar description',
      noDescription: 'No description found',
      addPassword: 'Add page password?',
      saveDetails: 'SAVE DETAILS',
      clear: 'clear',
      removedMessage: ' Removed',
      addParticipant: 'add participant',
      previewEmail: 'edit invitation email',
      import: 'import',
      invite: 'Invite & Manage participants',
      inviteSubheading: 'Add manually, share a link or import a list or CSV.',
      tableHeading: {
        guests: 'Guests',
        email: 'Email Address',
        user: 'Register/User'
      },
      tableOptions: {
        add: 'Add Guest',
        import: 'Import List',
        sendAll: 'Send Invite to ALL Participants',
        removeAll: 'Remove ALL Participants'
      },
      sentEmailMessage: 'Sent email invite to ',
      participants: ' participants',
      multipleRemovedMessage: ' participants removed',
      selected: ' participants selected',
      singleRemoved: ' Removed',
      send: 'Send Invites',
      remove: 'Remove Guests',
      tooltipInvite: 'Send invite email',
      tooltipRemove: 'Remove',
      noParticipants:
        'You have no participants in your seminar, please add some',
      removeModal: {
        heading: 'Remove ',
        body: 'Are you sure you want to REMOVE ',
        seminar: ' from seminar?'
      },
      dismiss: 'dismiss'
    },
    inviteModal: {
      invited: ' invited to seminar',
      inviteParticipant: 'Invite Participant',
      name: 'participant name',
      student: 'Student',
      teacher: 'Teacher',
      facilitator: 'Facilitator',
      invite: 'invite',
      listWith: ' lists with ',
      imported: ' contacts imported',
      shareToImport: 'Share contact list to import',
      listLelected: ' Lists selected',
      membersSelected: ' members selected',
      inviteAll: 'Invite ',
      participantToSeminar: ' Participants to Seminar?',
      noParticipants: 'No participants to import',
      sureNotify: 'Are you sure you want to notify and INVITE ALL ',
      all: 'invite all',
      sentInvite: 'Sent invite to ALL ',
      participants: ' Participants',
      deletedAllMessage: 'All Participants removed from seminar',
      sureRemoveAll:
        'Are you sure you want to REMOVE ALL Participants to the seminar?',
      removeAll: 'remove all',
      recording: {
        date: 'Date',
        name: 'Name',
        size: 'Size',
        duration: 'Duration',
        download: 'download',
        plya: 'play',
        404: 'No recordings found'
      },
      settings: {
        global: 'Global settings for ',
        timezone: 'Timezone',
        language: 'Language',
        bitrate: 'Bitrate',
        videoCodec: 'Video Codec',
        turn: 'Force Turn Server',
      },
    },
    previewModal: {
      subject: 'Subject',
      body: 'Body',
      save: 'save',
      default: 'set default',
      close: 'CLOSE'
    },
    forgotPassword: {
      sent: 'Email sent. ',
      sendAgain: 'Send link again?',
      successLine1: 'We\'ve sent you a link to change',
      successLine2: 'your password',
      checkSpam: 'If you don’t see our email, check your spam folder',
      resetByEMail: 'Reset your password by email',
      buttonLabel: 'send link'
    },
    signUp: {
      heading: 'Sign up for free!',
      doneHeading: 'Thanks for signing up!',
      passwordError: {
        short: 'Password too short, atleast 8 characters required',
        alphaNumeric: 'Password must contain both alphabets and numbers',
        dontMatch: 'Passwords don\'t match'
      },
      emailError: 'Email format is not correct',
      admin: 'Admin',
      guest: 'Guest',
      agree: 'By creating an account you agree to our',
      and: ' and ',
      confirmPasswordLabel: 'Confirm password',
      emailTaken: 'Email has already been taken',
      createAccount: 'create account',
      usernameLabel: 'Username'
    },
    signupComplete: {
      hi: 'Hi ',
      thanks: 'Thanks for signing up, please check your',
      activate: 'email to activate your account',
      redirect: 'Redirecting you in ',
      thanksActivate: 'Thanks for Account Activation',
      expiredHeading: 'Expired URL',
      expiredText: 'You\'ve jumped to the expired url Try again.',
      ActivationText:
        'Thanks Thanks Thanks for the activation, please login and create new seminar with workshop',
      resetSuccessfullMessage:
        'Your password has been updeted. you can now login with the new password',
      successChangeEmail: 'Success for Changing Email Address',
      changeEmailSuccessfullMessage:
        'You succeeded to change the email address, now you can login with the new email address.'
    },
    seminars: {
      emptyRoom: 'No rooms found, please create a rooms'
    },
    contacts: {
      csvImport: 'CSV Import',
      importCsv: 'Import CSV File',
      supportedFormat: 'Supported Format',
      chooseCsv: 'Choose CSV file',
      listName: 'List Name',
      create: 'Create List',
      list: 'List',
      edit: 'edit name',
      delete: 'delete',
      add: 'Add Person',
      role: 'Role',
      selected: ' guests selected',
      remove: 'Remove Guests',
      removed: ' guests removed',
      tooltipEdit: 'edit contact',
      tooltipRemove: 'Remove',
      userEdited: 'user edited',
      userAdded: 'user added',
      name: 'Guest name',
      save: 'save',
      addLabel: 'add',
      editLabel: 'edit',
      deleteList: 'Delete List',
      sureDelete: 'Are you sure you want to DELETE this list?'
    },
    settings: {
      account: 'account',
      billing: 'Billing & usage',
      unlimited: 'unlimited',
      picMessage: 'Picture updated',
      userType: 'User type',
      saved: 'Saved',
      confirmDelete: 'Confirm deletion of account',
      deleteAccount: 'Delete account??',
      typeMessage: {
        type: 'Type ',
        accountName: ' to confirm deletion of your account.',
        delete: 'DELETE'
      },
      sureDelete: 'Are you sure you want to delete your account?',
      deleteMessage:
        'All past and future seminars will be deleted and you will not have access to your account anymore',
      deleteButtonLabel: 'delete account',
      updateEmail: 'Check the confimation email',
      emailAlreadyGot: 'This email has already used'
    },
    picture: {
      take: 'Take',
      upload: 'Upload',
      picture: 'picture!',
      dropImage: 'Drop an image or click to select a file to upload.',
      confirm: 'confirm',
      takePic: 'take picture'
    },
    plan: {
      yourPlan: 'Your plan',
      plan: ' plan',
      enjoyBenefits:
        'Enjoy all the benefits of Workshop free features. Please check your usage details below:',
      seminarsMonth: 'Seminars a month',
      concurrentSeminars: 'Concurrent Seminar',
      maxParticipants: 'Max Participants',
      recordingStorage: 'Seminar recording storage',
      upgradeAccess: 'Upgrade to access',
      enjoyMore:
        'To enjoy more features of Workshop please upgrade and visit our plans page for more details.',
      contactUs:
        'Please contact us if you require a custom applications or integrations for your Workshop account. Email: nakajima@anets.co.jp',
      mangePlan: 'Plan Detail',
      currentPlan: 'current plan',
      backToFree: 'back to free',
      upgrade: 'upgrade',
      upgradeFailed: 'Upgrade Failed!',
      paymentFailed:
        'The payment has failed due to some reason, try again later?',
      close: 'close',
      changing: 'Changing Plan?',
      noRefund: 'No Refund Warning.',
      sure: 'Are you sure you want to ',
      upgradeTo: 'upgrade to ',
      switchBack: 'switch back to a Free account?',
      warning:
        'If you purchase a paid Workshop plan and then downgrade to a Free plan after using the paid plan, Anet Co., Ltd is not able to issue refunds for unused service.'
    },
    mangePlan: {
      settings: 'Settings',
      manage: 'Manage plans',
      heading:
        'Simple pricing for all! Select a plan that suites your needs, alternatively contact us if you require a customized solution.',
      monthly: 'Monthly contract',
      yearly: 'Yearly contract 20% OFF',
      month: 'month',
      year: 'year',
      updateCard: 'update card',
      updateCreditCard: 'update credit card',
      FAQ: 'Frequent Questions'
    },
    planFeatures: {
      feature1: 'x3 Seminars a month',
      featureNotFree1: 'Unlimited Seminars',
      tooltip1: 'The maximum number of active seminar rooms allocated',
      feature2: 'Breakout Rooms',
      tooltip2: 'Create mini rooms inside seminars for further discussion',
      feature3: {
        upTo: 'up to ',
        participants: ' participants'
      },
      tooltip3: 'The maximum number participants allowed per seminar',
      feature4: 'Text Chat',
      tooltip4:
        'Users can communicate with each other by text chat during the seminars.',
      feature5: 'Contact Management',
      tooltip5: 'Contact lists can be imported when inviting the participants.',
      feature6: '1 Concurrent Seminar',
      tooltip6: 'Manage and run multiple seminars at the same time',
      feature7: 'GB Seminar Recording',
      tooltip7: 'The maximum storage size for the recoding file',
      feature8: 'Email Support',
      tooltip8: 'We support users by email if you need help'
    },
    planHeading: {
      per: '/ per ',
      zero: '¥0 forever!',
      monthly: 'or ¥240,000 yearly equal to ¥20,000 per month',
      yearly: 'or ¥720,000 yearly equal to ¥60,000 per month',
      freeHeading: 'For a taste of Workshop you get:',
      starterHeading: 'Everything in free, plus:',
      premiumHeading: 'Everything in starter, plus:'
    },
    faq: {
      pricing: 'Pricing FAQ',
      question1: 'Q. What credit cards are available?',
      answer1:
        'For Workshop, VISA, MasterCard, American Express, JCB are available.',
      question2: 'Q. Do you correspond to bill payment?',
      answer2:
        'In the case of Ask plan, we can deal with it. Please contact us if you wish. (In the case of monthly payment, we have received a separate invoice issue fee.)',
      question3: 'Q. Can I change the plan even during the contract term?',
      answer3:
        'Yes. You can change the plan at any time and immediately use it in the plan after change. The price is calculated on the basis of the daily dividend and will not be charged in duplicate with the previous payment.',
      question4:
        'Q. Is there a refund when canceling in the middle of the contract period (change to free plan)?',
      answer4: 'I\'m sorry. We do not support refunds.',
      question5: 'Q. Is it possible to exchange contracts?',
      answer5:
        'Workshop is used with agreement to the Terms of Use and Privacy Policy, and we have not concluded individual NDA (Confidentiality Agreement) or outsourcing agreement etc. Please contact us if there are unavoidable circumstances.'
    },
    registration: {
      emailRegistered: 'This email is already registered',
      noAccount:
        'You registered as a participants! Please create the new account with that!',
      accountExists: 'You registered as a participants!'
    },
    DomainFVliteNavigation: {
      create: 'Create a new FVlite domain',
      news: 'Edit the news section in FreshVoice FVlite',
    },
    DomainWebinarNavigation: {
      create: 'Create a new webinar domain',
      news: 'Edit the news section in FreshVoice Webinar',
      dd_news: 'Edit the news section in DD'
    }
  },
  ja: {
    login: {
      heading: 'ウェビナーの開催をどうぞ',
      subHeading: '',
      forgotPassword: 'パスワードを忘れました',
      remember: 'ログインを保存',
      passwordLable: 'パスワード',
      emailLable: 'Eメールアドレス',
      requiredField: '入力してください',
      buttonLabel: 'ログイン',
      invalidPassword: 'パスワードが間違っています。正しいパスワードを入力してください。',
      noUser: 'ユーザーが見つかりません。',
      emailNotFound: 'Emailが見つかりません。',
      newAccountLabel: '新しいアカウントを作成します。'
    },
    footerMenu: {
      about:
        '<a class="link white" href="https://www.anets.co.jp/company/">私たちに関しては</a>',
      terms:
        '<a class="link black" href="https://workshop-live.com/term-jp.html">利用規約</a>',
      policy:
        '<a class="link black" href="https://workshop-live.com/privacy-jp.html">プライバシーポリシー</a>',
      developedBy: 'によって作成された '
    },
    loggedOutNavigation: {
      home: 'ホーム',
      register: '新規アカウント作成'
    },
    loggedInNavigation: {
      adminDashboard: '管理者用ダッシュボード',
      guestDashboard: 'ゲスト用ダッシュボード',
      roleAdmin: '管理者',
      roleGuest: '参加者',
      contacts: 'アドレス帳',
      settings: '設定',
      recordings: 'レコーディング',
      seminars: 'セミナー',
      rooms: 'セミナー',
      upgrade: 'アップグレード',
      new: 'セミナー作成',
      modalHeader: 'アップグレード',
      upgradeConfirmation: 'アドミンへアップグレードしますか?',
      upgradeModalBody: '月2回まで、無料でワークショップを開催することができます。',
      cancel: 'キャンセル',
      gotoAdmin: 'アドミンダッシュボードへ',
      gotoGuest: 'ゲストダッシュボードへ',
      logout: 'ログアウト',
      adminster: 'ゲストはセミナー開催できません',
      manual: 'マニュアル',
      news: 'お知らせ'
    },
    seminar: {
      registration: '参加者として登録',
      beginsIn: '開催時刻は',
      register: '参加者の登録画面へ行く',
      guests: '人',
      open: 'セミナー画面へ行く',
      upcoming: '未開催',
      previous: '開催済み',
      deleteSeminar: '削除',
      declineInvite: '参加拒否',
      acceptInvite: '参加登録',
      openSeminar: 'セミナー画面',
      deleteModalHeading: 'セミナーを削除しますか？',
      deleteConfirm: {
        sure: '本当に削除しますか？ ',
        seminar: ' が削除されます。',
        guestNumbers: '人招待しています'
      },
      deleteButtonLabel: '削除',
      delMessage: 'セミナーが削除されました',
      schedule: 'セミナー開催日時',
      scheduleUpdated: '開催日時が更新されました',
      date: '日付',
      time: '時刻',
      save: '保存',
      notScheduled: 'セミナー開催日時が設定されていません',
      dateNot: 'セミナー開催日時を設定されていません',
      scheduleNext: 'セミナー開催日時を設定してください',
      createNew: 'セミナー作成',
      seminarName: 'セミナーの名前',
      on: 'オン',
      off: 'オフ',
      record: 'セミナー映像を録画',
      create: '作成',
      mobile: 'ディスカッションモード'
    },
    seminarActions: {
      members: '人',
      select: '選択済み',
      selectList: '選択',
      tabs: {
        details: '詳細',
        schedule: '開催日時',
        invite: '参加者',
        recording: '録画映像',
        settings: '設定'
      },
      name: '名前',
      description: '説明',
      noDescription: '説明がありません',
      addPassword: 'パスワード',
      saveDetails: '保存',
      clear: 'クリア',
      removedMessage: ' 削除済み',
      addParticipant: '参加者追加',
      previewEmail: '招待メールの編集',
      import: 'インポート',
      invite: '参加者の招待と管理',
      inviteSubheading: '手動で入力、アドレス帳のインポートができます',
      tableHeading: {
        guests: '名前',
        email: 'Eメールアドレス',
        user: '状態/役割'
      },
      tableOptions: {
        add: '追加',
        import: 'インポート',
        sendAll: 'すべての参加者に招待メールを送信する',
        removeAll: 'すべての参加者を削除する'
      },
      sentEmailMessage: '招待メールを送信しました ',
      participants: ' 参加者',
      multipleRemovedMessage: ' 参加者が削除されました',
      selected: ' 人選択',
      singleRemoved: ' 削除された',
      send: '招待メールを送信する',
      remove: '削除する',
      tooltipInvite: '招待メール送信',
      tooltipRemove: '削除',
      noParticipants: '参加者はいません。追加してください。',
      removeModal: {
        heading: '取り除く ',
        body: '本当に削除しますか？ ',
        seminar: '**'
      },
      dismiss: '閉じる'
    },
    inviteModal: {
      invited: ' セミナーに招待されました',
      inviteParticipant: '参加者の追加',
      name: '名前',
      student: '受講者',
      teacher: 'プレゼンター',
      facilitator: 'アシスタント',
      invite: 'リストに追加する',
      listWith: ' リスト ',
      imported: ' インポートされた連絡先',
      shareToImport: 'アドレス帳から選択',
      listLelected: ' つ選択中',
      membersSelected: ' 人追加されます',
      inviteAll: 'すべての参加者(',
      participantToSeminar: ' 人)へ招待メールを送りますか?',
      noParticipants: 'インポートする参加者はいません',
      sureNotify: 'すべてを通知して招待しますか？ ',
      all: 'すべてを招待する',
      sentInvite: 'すべてに招待状を送信しました ',
      participants: ' 参加者',
      deletedAllMessage: 'セミナーからすべての参加者が削除されました',
      sureRemoveAll: 'すべての参加者を削除します。この操作は取り消せません。',
      removeAll: 'すべて削除する',
      recording: {
        date: '日付',
        name: 'ファイル名',
        size: 'ファイルサイズ',
        duration: '長さ',
        download: 'ダウンロード',
        play: '遊ぶ',
        404: '録画映像はありません'
      },
      settings: {
        global: '設定 for ',
        timezone: 'タイムゾーン',
        language: '使用言語',
        bitrate: 'ビットレート',
        videoCodec: '映像コーデック',
        turn: 'Turn Serverの強制'
      }
    },
    previewModal: {
      subject: '件名',
      save: '保存する',
      default: 'デフォルトに戻す',
      body: '本体',
      close: '閉じる'
    },
    forgotPassword: {
      sent: '送信完了',
      sendAgain: ' ',
      successLine1: 'パスワード設定リンクを送信しました。',
      successLine2: 'メールがしばらく経っても届かない場合は、迷惑メールフォルダをチェックしてください。',
      checkSpam: ' ',
      resetByEMail: 'パスワードの再設定をEmailで行います。',
      buttonLabel: '送信'
    },
    signUp: {
      heading: '新規アカウント作成',
      doneHeading: '作成に成功しました。',
      passwordError: {
        short: '8文字以上で設定してください。',
        alphaNumeric: '数字とアルファベットの両方を1文字以上使用してください。',
        dontMatch: 'パスワードが一致しません。'
      },
      emailError: 'Emailの形式が正しくありません。',
      admin: '管理者',
      guest: 'ゲスト',
      agree: '本サービスのアカウントを作成することにより, 次の規約に同意したものとみなされます。',
      and: 'と',
      confirmPasswordLabel: 'パスワードの確認',
      emailTaken: 'このEmailは既に利用されています。',
      createAccount: 'アカウント作成',
      usernameLabel: 'ユーザ名'
    },
    signupComplete: {
      hi: 'こんにちは',
      thanks: ' ',
      activate: '確認用のメールを送りました。ご確認ください。',
      redirect: '自動でトップ画面へ戻ります。',
      thanksActivate: 'アカウントのアクティベーションをありがとう',
      expiredHeading: '期限切れのURL',
      expiredText: '無効なURLへアクセスしました。',
      ActivationText: 'アカウントのアクィベーションに成功しました。ログインして、セミナーの参加や作成をしてください。',
      resetSuccessfullMessage: 'パスワードの更新に成功しました。新しいパスワードでログインすることができます。',
      successChangeEmail: 'メールアドレスの変更に成功',
      changeEmailSuccessfullMessage:
        'Emailアドレスの変更に成功しました。新しいEmailアドレスでログインできます。'
    },
    seminars: {
      emptyRoom: '表示可能なセミナーなし'
    },
    contacts: {
      csvImport: 'CSV インポート',
      importCsv: ' CSV Fileをインポートする',
      supportedFormat: '対応フォーマット',
      chooseCsv: 'ファイルをここに置いてください。もしくはクリックしてください。',
      listName: 'アドレス帳の名前',
      create: '新規リスト作成',
      list: 'アドレス帳',
      edit: '名前の編集',
      delete: '削除',
      add: '追加',
      role: '役割',
      selected: ' 人選択',
      remove: '削除する',
      removed: ' ** ',
      tooltipEdit: '編集',
      tooltipRemove: '削除',
      userEdited: '更新しました。',
      userAdded: '追加しました。',
      name: '名前',
      save: '保存',
      addLabel: '作成',
      editLabel: '編集',
      deleteList: 'アドレス帳の削除',
      sureDelete: 'このアドレス帳を削除しますか？この操作は取り消しできません。'
    },
    settings: {
      account: 'アカウント設定',
      billing: '契約情報',
      unlimited: '無制限',
      picMessage: '画像を更新しました',
      userType: '現在のプラン',
      saved: '保存完了',
      confirmDelete: 'アカウント削除の確定',
      deleteAccount: 'アカウント削除',
      typeMessage: {
        type: '確認のために、',
        accountName: ' と入力してください。',
        delete: '削除'
      },
      sureDelete: 'アカウントの削除を行いますか？削除すると、支払った代金の返金はされません。また、アカウントの復元は対応しておりません。',
      deleteMessage: ' ',
      deleteButtonLabel: 'アカウント削除',
      updateEmail: '確認のメールをチェックしてください',
      emailAlreadyGot: 'このEmailは既に利用されています'
    },
    picture: {
      take: 'プロフィール写真の撮影',
      upload: 'プロフィール写真のアップロード',
      picture: ' ',
      dropImage: '画像ファイルのドラッグ&ドロップ、または画像ファイルの選択をしてください。',
      confirm: '確定',
      takePic: '撮影'
    },
    plan: {
      yourPlan: '現在のプラン',
      plan: ' plan',
      enjoyBenefits: '無料プランでは次の利用制約がございます。',
      seminarsMonth: 'セミナー開催の回数(/月)',
      concurrentSeminars: '同時開催の回数(/月)',
      maxParticipants: '最大参加者数(/人)',
      recordingStorage: '録画容量',
      upgradeAccess: 'なし',
      enjoyMore: '利用制約を解除するにはプランのアップグレードが必要です。',
      contactUs: 'カスタマイズが必要な場合や同時開催数を増やしたい場合はお問い合わせください。Email: nakajima@anets.co.jp',
      mangePlan: 'プランの詳細',
      currentPlan: '現在のプラン',
      backToFree: 'フリープランへ戻す',
      upgrade: '選択',
      upgradeFailed: 'アップグレードが失敗しました。',
      paymentFailed: '決済が失敗しました。もう一度トライしてください。',
      close: '**',
      changing: 'プランを変更しますか?',
      noRefund: ' ',
      sure: ' ',
      upgradeTo: ' ',
      switchBack: '**',
      warning: 'フリープランへ変更します。既にお支払い頂いた代金の返金は致しかねます。ご了承ください。'
    },
    mangePlan: {
      settings: '設定',
      manage: 'プランの詳細',
      heading: 'お客様のニーズにあったプランをお選び下さい。お支払い方法はクレジット決済にのみ対応しております。',
      monthly: '月々支払い',
      yearly: '年間一括払い 20% OFF',
      month: '月',
      year: '年',
      updateCard: '更新',
      updateCreditCard: 'クレジットカード情報の更新',
      FAQ: '料金プランに関する質問'
    },
    planFeatures: {
      feature1: '月3回のセミナー開催',
      featureNotFree1: '月3回のセミナー開催',
      tooltip1: '１月当たりに最大で開催できるセミナー数を表しています。',
      feature2: 'ディスカッションモード',
      tooltip2:
        '参加者をテーブルごとに割り当て、ディスカッションさせることができます。また、プレゼンターとアシスタントはテーブルごとの音声を聞いたり、ディスカッションに参加することができます。',
      feature3: {
        upTo: '最大 ',
        participants: ' 人の参加'
      },
      tooltip3: '1セミナー当たりの最大参加者数です。',
      feature4: 'テキストチャット',
      tooltip4: 'セミナー中にテキストによるチャットが可能です。',
      feature5: 'アドレス帳管理',
      tooltip5: 'アドレス帳は新しいセミナーの参加者を追加する際に便利です。',
      feature6: '同時開催数 1',
      tooltip6: '同時に開催できるセミナーの上限数です。複数のセミナーを同時開催した場合はお問いあわせください。',
      feature7: 'GB 録画ストレージ',
      tooltip7: '録画映像のストレージ容量です。これを超える場合は録画機能が働きません。',
      feature8: 'Emailサポート',
      tooltip8: '営業時間中( 9:00 ~ 17:00 ) にEmailによる使い方やご不明な点などのサポートを行います。'
    },
    planHeading: {
      per: '/  ',
      zero: '無料!',
      monthly: '年間一括払いで ¥240,000 ( 1月当たり ¥20,000 )',
      yearly: '年間一括払いで ¥720,000 ( 1月当たり ¥60,000 )',
      freeHeading: 'お試しにご利用ください。',
      starterHeading: ' ',
      premiumHeading: ' '
    },
    faq: {
      pricing: '料金プランに関する質問',
      question1: 'Q. 利用可能なクレジットカードを教えてください。',
      answer1: 'Workshop ではVISA、MasterCard、American Express、JCBが利用可能です。',
      question2: 'Q. 請求書払いには対応していますか？',
      answer2:
        'カスタマイズが必要な場合または同時開催数を増やす場合は利用可能です。ご希望の場合はお問い合わせください。（月払いの場合、別途請求書発行手数料をいただいております。）',
      question3: 'Q. 契約期間の途中でもプランの変更はできますか？',
      answer3:
        'はい。プランはいつでも変更でき、すぐに変更後のプランにてご利用いただけます。料金は日割りした差額が計算され、前回の支払分と重複して請求されることはありません。',
      question4: 'Q. 契約期間の途中で解約した場合に払い戻しはありますか？また、どうやって解約できますか？',
      answer4: '申し訳ございません。払い戻しには対応しておりません。解約はフリープランへ変更することによりできます。',
      question5: 'Q. 契約書を取り交わすことはできますか？',
      answer5:
        'Workshop では 利用規約 およびプライバシーポリシーに同意いただいてのご利用とさせていただいており、個別の NDA（機密保持契約書）や、業務委託契約書等の締結は行っておりません。やむを得ない事情がある場合はお問い合わせください。'
    },
    registration: {
      emailRegistered: '既に参加者として登録されています。',
      noAccount: '登録が完了しました! アカウントを作成してください！',
      accountExists: '参加者としての登録が完了しました!'
    },
    DomainNavigation: {
      create: 'ウェビナードメインの新規作成',
      news: 'FreshVoice FVlite お知らせの編集',
    },
    DomainWebinarNavigation: {
      create: 'ウェビナードメインの新規作成 ',
      news: 'FreshVoice Webinar お知らせの編集',
      dd_news: 'DD お知らせの編集'
    }
  }
}



// WEBPACK FOOTER //
// ./src/messages.js